export const allCities = [
  'Bangalore',
  'Coimbatore',
  'Mumbai',
  'Chennai',
  'Noida',
  'Delhi',
  'Gurgaon',
  'Pune',
  'Hyderabad',
  'Kolkata',
  'Ahmedabad',
  'Jaipur',
  'Lucknow',
  'Faridabad',
  'Ghaziabad',
  'Visakhapatnam',
  'Chandigarh',
  'Cochin',
  'Nagpur',
  'Indore',
  'Vijayawada',
  'Durgapur',
  'Asansol',
  'Bhubaneswar',
  'Guwahati',
  'Surat',
  'Vadodara',
  'Nashik',
  'Bhopal',
  'Salem',
]

export const cityGroup1 = [
  'Bangalore',
  'Coimbatore',
  'Mumbai',
  'Chennai',
  'Noida',
  'Delhi',
  'Gurgaon',
  'Pune',
  'Hyderabad',
  'Kolkata',
  'Jaipur',
  'Lucknow',
  'Faridabad',
  'Ghaziabad',
  'Visakhapatnam',
  'Chandigarh',
  'Nagpur',
  'Indore',
  'Mysore',
  'Ludhiana',
  'Vijayawada',
  'Durgapur',
  'Asansol',
  'Bhubaneswar',
  'Guwahati',
  'Salem',
]

export const cityGroup2 = [
  'Bangalore',
  'Coimbatore',
  'Mumbai',
  'Chennai',
  'Noida',
  'Delhi',
  'Gurgaon',
  'Pune',
  'Hyderabad',
  'Kolkata',
  'Lucknow',
  'Jaipur',
  'Faridabad',
  'Ghaziabad',
  'Visakhapatnam',
  'Chandigarh',
  'Nagpur',
  'Indore',
  'Mysore',
  'Ludhiana',
  'Vijayawada',
  'Durgapur',
  'Asansol',
  'Bhubaneswar',
  'Guwahati',
  'Salem',
]

export const serviceCityGroupMapping = {
  'Lab Tests': cityGroup1,
  Nursing: cityGroup2,
  Physiotherapy: cityGroup1,
  Vaccination: cityGroup2,
  'Elder Care': cityGroup2,
  'Nursing Care': cityGroup2,
  'Doctor Visit': cityGroup1,
  'Mother & Baby Care': cityGroup2,
  'Nutrition Consulting': cityGroup2,
  'Medical Equipment': cityGroup2,
  'Doctor Consultation': allCities,
  'Diabetes Care': allCities,
  'Critical Care': allCities,
  'Trained Attendants': allCities,
  'Nutrition & Diet Consultation': allCities,
  Counselling: allCities,
  Diagnostics: allCities,
}

const additionalServices = ['Nutrition & Diet Consultation', 'Counselling']
